import clocknpay from "../img/clocknpay.png";
import Purpleroof from "../img/purpleroof.png";
import Learndev from "../img/learndev.png";
import Gabby from "../img/Coverchatbot.png";
import Posh from "../img/posh.png";
import Smart from "../img/smart.png";
import Canbe from "../img/canbe-image.png";
import Sabms from "../img/sabms.png";
import PhotoAlbumCraft from "../img/photoalbumcraftai.png";
import Mvmis from "../img/mvmis.png";
import SmartMomo from "../img/smart-momo.png";

const projectsData = [
  // {
  //   title: "AI - Meal Planner App",
  //   description: `Created a side-project AI Meal Planner application`,
  //   tags: [
  //     "Next js",
  //     "Next Auth",
  //     "Neon",
  //     "Trpc",
  //     "Tailwind CSS",
  //     "Postgresql",
  //     "Prisma ORM",
  //     "Node js",
  //     "Typescript",
  //     "Antropic API",
  //     "AWS Amplify"
  //   ],
  //   imageUrl: undefined,
  //   link: undefined,
  //   route: undefined,
  //   buttonType: "See Website",
  //   buttonCta: "Learn more",
  // },
  {
    title: "Smart Momo",
    description: `Smart Momo is a Learning Management System for schools that brings rosters, lessons, submissions, grading, timed assessments and attendance into one place, with role-specific views for teachers and students, a priority grading queue, gradebook with GPA, and early intervention alerts.`,
    tags: ["Next js", "Tailwind", "Typescript", "Node js"],
    imageUrl: SmartMomo,
    link: "https://www.smart-momo.com/",
    route: undefined,
    buttonType: "See Website",
    buttonCta: "Learn more",
  },
  {
    title: "SABMS",
    description: `Asset Borrowing & Management System, a school property monitoring system to record school equipment, release it to faculty and students, and confirm every item makes its way back, replacing manual logbooks with live inventory, borrow requests and room tracking.`,
    tags: ["Next js", "Tailwind", "Typescript", "Node js"],
    imageUrl: Sabms,
    link: "https://www.sabms.online/",
    route: undefined,
    buttonType: "See Website",
    buttonCta: "Learn more",
  },
  {
    title: "Photo Album Craft AI",
    description: `Photo Album Craft AI is an AI-powered photo album builder, users describe the story they want to tell, from wedding highlights and travel journals to a baby's first year, and the AI crafts the album for them.`,
    tags: ["Next js", "Tailwind", "Typescript", "AI Integrations"],
    imageUrl: PhotoAlbumCraft,
    link: "https://www.photoalbumcraftai.com/",
    route: undefined,
    buttonType: "See Website",
    buttonCta: "Learn more",
  },
  {
    title: "MVMIS",
    description: `Vehicle Management Information System built for TCX Motors, an internal platform to manage the company's vehicle records and operations behind a secure staff login.`,
    tags: ["Next js", "Tailwind", "Typescript"],
    imageUrl: Mvmis,
    link: "https://www.mvmis.com/",
    route: undefined,
    buttonType: "See Website",
    buttonCta: "Learn more",
  },
  {
    title: "canbestudios.com",
    description: `recreate the the web page design for video editing using wix`,
    tags: [
      "Wix",
    ],
    imageUrl: Canbe,
    link: "https://www.canbestudios.com/",
    route: undefined,
    buttonType: "See Website",
    buttonCta: "Learn more",
  },
  {
    title: "Clocknpay",
    description:
      "In my recent professional endeavor, I had the privilege of collaborate and contribute closely with a dynamic team to create and develop the UI design landing page for ClocknPay Mobile App.",
    tags: ["Next js", "Tailwind", "Node js"],
    imageUrl: clocknpay,
    link: "https://clocknpay.netlify.app/",
    route: undefined,
    buttonType: "See App",
    buttonCta: "Learn more",
  },
  {
    title: "PurpleRoof",
    description:
      "In my previous job as a Web Developer, I undertook a dynamic project to collaborated with the team to integrate recaptcha, chat notification sidebar, and more to the PurpleRoof CMS.",
    tags: ["React", "Next.js", "Tailwind", "Typescript"],
    imageUrl: Purpleroof,
    link: "https://purpleroof.com/",
    route: undefined,
    buttonType: "Explore App",
    buttonCta: "Learn more",
  },
  {
    title: "Poshsidekick",
    description: `In my previous job as a Web Developer 1, I undertook a dynamic collaborative project on React-Native with the CTO to help set-up a key features to the Poshsidekick app this is the feature we build <a href="https://www.youtube.com/watch?v=ZccWRa4jLoQ" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline">automated live selling.</a>`,
    tags: [
      "React Native",
      "Expo",
      "Typescript",
      "Node js",
      "Express js",
      "Prisma ORM",
      "React CSS",
      "React Native Components",
    ],
    imageUrl: Posh,
    link: "https://www.youtube.com/watch?v=ZccWRa4jLoQ",
    route: undefined,
    buttonType: "Learn More",
    buttonCta: "Learn more",
  },
  {
    title: "Smartstudio",
    description:
      "In my previous job as a Web Developer, I undertook a dynamic project to collaborated and contributed on the Front-end, to add and refactor certain user-interface in the Smartstudio website.",
    tags: ["Next.js", "Tailwind", "Typescript"],
    imageUrl: Smart,
    link: "https://www.smartsite.studio/",
    route: undefined,
    buttonType: "See App",
    buttonCta: "Learn more",
  },
  {
    title: "LearnDev",
    description:
      "Embarking on the development of my Learn-Dev App from scratch, I aimed to create a tailored learning platform.",
    tags: ["React", "Next.js", "Youtube API", "Tailwind", "Daisy UI"],
    imageUrl: Learndev,
    link: "https://learn-dev-one.vercel.app/",
    route: undefined,
    buttonType: "See Demo",
    buttonCta: "Learn more",
  },
  {
    title: "Gabby",
    description:
      "In my freelance role, I undertook a dynamic project-based to develop a mobile application and design the user interface for a chatbot named Gabie. ",
    tags: ["React Native", "Firebase", "Dialogflow"],
    imageUrl: Gabby,
    link: "https://github.com/Nevram30/Gabie-chatbot",
    route: undefined,
    buttonType: "Explore Code",
    buttonCta: "Learn more",
  },
];

export default projectsData;
